import React from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";

import AuthenticateNone from "./AuthenticateNone";
import AuthenticateClioAlasql from "./AuthenticateClioAlasql";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    alignContent: "center",
    justifyContent: "center",

    flexWrap: "wrap",
    margin: theme.spacing(6),
    height: `calc(100vh - ${theme.spacing() + 78}px)`,
    width: `calc(100% - ${theme.spacing(2)}px) !important`,
    position: "relative",
  },
  box: {
    margin: "50px",
  },
}));

export const AppAuthentication = ({ authData, origin }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {process.env.REACT_APP_STAGE !== "production" && (
        <div className={classes.box}>
          <AuthenticateNone></AuthenticateNone>
        </div>
      )}
      <div className={classes.box}>
        <AuthenticateClioAlasql authData={authData} engine={"alasql"} origin={origin}></AuthenticateClioAlasql>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(AppAuthentication);
